<template>
  <a-card v-show="configMeta.length">
    <v-row wrap>
      <v-col class="py-0" v-for="meta in configMeta" :cols="meta.cols || 6" :key="meta.key">
        <ParkingDialogWrapper
          v-if="meta.key === 'parking'"
          :config="meta"
          :value="metaValues[meta.key]"
          :country="country"
          @input="(v) => updateField(meta.key, v)"
        />
        <a-field
          v-else-if="meta.key === 'foc'"
          :config="meta"
          :value="metaValues[meta.key]"
          :country="country"
          :env="env"
          :list="focOptions"
          clearable
          @input="(v) => updateField(meta.key, v)"
        />
        <div v-else-if="meta.key === 'breakfast'">
          <a-field
            :config="meta"
            :value="metaValues[meta.key]"
            :country="country"
            :env="env"
            clearable
            @input="(v) => updateField(meta.key, v)"
          />
          <g-button class="mt-2" label="Breakfast Technical" icon="notes" @onclick="breakfastTechnicalDialog = true" />
        </div>
        <a-field
          v-else
          :config="meta"
          :value="metaValues[meta.key]"
          :country="country"
          :env="env"
          clearable
          @input="(v) => updateField(meta.key, v)"
        />
      </v-col>
    </v-row>
    <BreakfastTechnicalDialog
      v-model="breakfastTechnicalDialog"
      :notes="metaValues.breakfast_technical"
      @save="(v) => updateField('breakfast_technical', v)"
    />
  </a-card>
</template>

<script>
import info from "../config/formConfig";
import BreakfastTechnicalDialog from "./_BreakfastTechnicalDialog";
import ParkingDialogWrapper from "./_ParkingDialogWrapper";

export default {
  props: {
    supplierType: String,
  },
  components: {
    BreakfastTechnicalDialog,
    ParkingDialogWrapper,
  },
  data() {
    return {
      breakfastTechnicalDialog: false,
    };
  },
  computed: {
    focOptions() {
      return this.supplierType === "HOTEL"
        ? [
            { label: "Cumulative", value: "Cumulative" },
            { label: "Per Night", value: "PerNight" },
          ]
        : [{ label: "Per Person", value: "PerPerson" }];
    },
    env() {
      return this.$store.getters["AccountStore/environment"];
    },
    configMeta() {
      const env = this.$store.getters["AccountStore/environment"];
      const config = this.supplierType ? info[this.supplierType] || {} : {};
      if (!config.meta) return false;

      // Filter out any meta not for this environment
      return Object.keys(config.meta)
        .filter((key) => {
          // No restriction, then return
          if (!config.meta[key].restrictEnv) return true;
          return config.meta[key].restrictEnv.includes(env);
        })
        .map((key) => {
          return {
            key,
            ...config.meta[key],
          };
        });
    },
    country() {
      return this.$store.getters["SupplierStore/country"];
    },
    metaValues() {
      return this.$store.getters["SupplierStore/meta"];
    },
  },
  methods: {
    updateField(key, value) {
      return this.$store.dispatch("SupplierStore/setUpdateMeta", { key, value });
    },
  },
};
</script>
